import { CHART_CATALOG, type ChartId } from 'charts/catalog/chartCatalog';
import type { StateCreator } from 'zustand';
import type { ChartUiState, ChartsUiSlice } from './types';

export * from './types';

export function createInitialChartsUiById(): Record<ChartId, ChartUiState> {
  return Object.fromEntries(
    CHART_CATALOG.map((entry) => [entry.id, { refreshVersion: 0 }])
  ) as Record<ChartId, ChartUiState>;
}

type ChartsUiSliceCreator = StateCreator<ChartsUiSlice, [], [], ChartsUiSlice>;

export const createChartsUiSlice: ChartsUiSliceCreator = (set) => ({
  chartsUiById: createInitialChartsUiById(),

  chartsUiActions: {
    invalidateChart: (id): void => {
      set((state) => ({
        chartsUiById: {
          ...state.chartsUiById,
          [id]: {
            refreshVersion: (state.chartsUiById[id]?.refreshVersion ?? 0) + 1,
          },
        },
      }));
    },

    resetChartsUi: (): void => {
      set({ chartsUiById: createInitialChartsUiById() });
    },
  },
});
